var _a, _b, _c, _d, _e;
import { __decorate, __metadata } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { RavenService } from '@cores/modules/raven-module/raven-service';
import { Message } from '@patsnap/tahiti-core/common/message';
import { I18nService } from '@/services/i18n-service';
import { ApiTransferSpace } from '@/infrastructure/api-functions/api-transfer-space';
import { SpacesModel } from '@/domains/spaces/model/spaces-model';
let TransferSpaceServiceImp = class TransferSpaceServiceImp {
    async transferSpace(spaces, transferOption) {
        this._ravenService.track('Transfer Workspace', {
            comment: transferOption.includeComments,
            emailAlert: transferOption.includeEmailAlerts,
            field: transferOption.includeCustomFields,
        });
        await this._apiTransferSpace.transferSpace({
            dst_user_id: transferOption.targetUserId,
            to_company_space: transferOption.transferCompanySpace ? true : undefined,
            spaces,
            need_comment: transferOption.includeComments,
            need_email_alert: transferOption.includeEmailAlerts,
            need_field: transferOption.includeCustomFields,
            type: 'transfer',
        });
        this._spacesModel.update(modelData => {
            return modelData.filter(space => !spaces.includes(space.spaceId));
        });
        this._message.success({
            message: this._i18nService.t('workspace.taskCenter.transferTaskTip'),
            duration: 5000,
            showClose: true,
            dangerouslyUseHTMLString: true,
        });
    }
};
__decorate([
    inject(RavenService),
    __metadata("design:type", typeof (_a = typeof RavenService !== "undefined" && RavenService) === "function" ? _a : Object)
], TransferSpaceServiceImp.prototype, "_ravenService", void 0);
__decorate([
    inject(Message),
    __metadata("design:type", typeof (_b = typeof Message !== "undefined" && Message) === "function" ? _b : Object)
], TransferSpaceServiceImp.prototype, "_message", void 0);
__decorate([
    inject(I18nService),
    __metadata("design:type", typeof (_c = typeof I18nService !== "undefined" && I18nService) === "function" ? _c : Object)
], TransferSpaceServiceImp.prototype, "_i18nService", void 0);
__decorate([
    inject(ApiTransferSpace),
    __metadata("design:type", typeof (_d = typeof ApiTransferSpace !== "undefined" && ApiTransferSpace) === "function" ? _d : Object)
], TransferSpaceServiceImp.prototype, "_apiTransferSpace", void 0);
__decorate([
    inject(SpacesModel),
    __metadata("design:type", typeof (_e = typeof SpacesModel !== "undefined" && SpacesModel) === "function" ? _e : Object)
], TransferSpaceServiceImp.prototype, "_spacesModel", void 0);
TransferSpaceServiceImp = __decorate([
    injectable()
], TransferSpaceServiceImp);
export { TransferSpaceServiceImp };
